// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---node-modules-prismicio-gatsby-source-prismic-graphql-components-preview-page-js": function componentNodeModulesPrismicioGatsbySourcePrismicGraphqlComponentsPreviewPageJs() {
    return import("./../@prismicio/gatsby-source-prismic-graphql/components/PreviewPage.js"
    /* webpackChunkName: "component---node-modules-prismicio-gatsby-source-prismic-graphql-components-preview-page-js" */
    );
  },
  "component---src-components-04-templates-landing-page-js": function componentSrcComponents04TemplatesLandingPageJs() {
    return import("./../../src/components/04 Templates/landing-page.js"
    /* webpackChunkName: "component---src-components-04-templates-landing-page-js" */
    );
  },
  "component---src-components-04-templates-news-landing-page-js": function componentSrcComponents04TemplatesNewsLandingPageJs() {
    return import("./../../src/components/04 Templates/news-landing-page.js"
    /* webpackChunkName: "component---src-components-04-templates-news-landing-page-js" */
    );
  },
  "component---src-components-05-pages-contact-js": function componentSrcComponents05PagesContactJs() {
    return import("./../../src/components/05 Pages/contact.js"
    /* webpackChunkName: "component---src-components-05-pages-contact-js" */
    );
  },
  "component---src-components-05-pages-content-post-js": function componentSrcComponents05PagesContentPostJs() {
    return import("./../../src/components/05 Pages/contentPost.js"
    /* webpackChunkName: "component---src-components-05-pages-content-post-js" */
    );
  },
  "component---src-components-05-pages-destination-js": function componentSrcComponents05PagesDestinationJs() {
    return import("./../../src/components/05 Pages/destination.js"
    /* webpackChunkName: "component---src-components-05-pages-destination-js" */
    );
  },
  "component---src-components-05-pages-gallery-js": function componentSrcComponents05PagesGalleryJs() {
    return import("./../../src/components/05 Pages/gallery.js"
    /* webpackChunkName: "component---src-components-05-pages-gallery-js" */
    );
  },
  "component---src-components-05-pages-inspiration-post-js": function componentSrcComponents05PagesInspirationPostJs() {
    return import("./../../src/components/05 Pages/inspirationPost.js"
    /* webpackChunkName: "component---src-components-05-pages-inspiration-post-js" */
    );
  },
  "component---src-components-05-pages-news-post-js": function componentSrcComponents05PagesNewsPostJs() {
    return import("./../../src/components/05 Pages/newsPost.js"
    /* webpackChunkName: "component---src-components-05-pages-news-post-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-success-js": function componentSrcPagesSuccessJs() {
    return import("./../../src/pages/success.js"
    /* webpackChunkName: "component---src-pages-success-js" */
    );
  }
};